import { render } from "./PartnerDeelnemer.vue?vue&type=template&id=4734d2c4&scoped=true"
import script from "./PartnerDeelnemer.vue?vue&type=script&lang=js"
export * from "./PartnerDeelnemer.vue?vue&type=script&lang=js"

import "./PartnerDeelnemer.vue?vue&type=style&index=0&id=4734d2c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4734d2c4"]])

export default __exports__